import { BrowserRouter, Route, Link } from "react-router-dom";

function CommunityMandala() {
  const images = [
    "/images/img1.png",
    "/images/img2.png",
    "/images/img3.png",
    "/images/img4.png",
    "/images/img5.png",
    "/images/img6.png",
  ];
  return (
    <div id="communityMandala">
      <div className="container">
        <h5 className="titleStyle">
          Cộng đồng <span>Mandala</span>
        </h5>
        <div className="communityRow">
          <div className="row ">
            {images.map((item, index) => {
              return (
                <div key={index} className="col-lg-4 col-6 itemBox">
                  <BrowserRouter> 
                    <Link to="/">
                      <img className="img-fluid" src={item} alt="" />
                    </Link>
                  </BrowserRouter>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CommunityMandala;
